import React, { useEffect, useRef, useState } from 'react';
import { plotStatusIds } from '../../../Enum';
import { FiChevronDown } from "react-icons/fi";
import { LiaFilterSolid } from "react-icons/lia";

const StatusDropdown = ({ onSelect }) => {
  const [selectedStatus, setSelectedStatus] = useState({ label: "All", id: "all" });
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setSelectedStatus(option);
    setOpen(false);
    if (onSelect) onSelect(option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        className="w-[150px] h-[50px] rounded-[10px] px-5 bg-white flex items-center justify-between gap-2 text-gray-700 text-base cursor-pointer shadow"
        onClick={() => setOpen(!open)}
      >
        <LiaFilterSolid className="text-customGreen font-semibold text-xl" />
        <div className='text-gray-800 font-medium truncate'>{selectedStatus.label}</div>
        <FiChevronDown
          className={`text-xl text-gray-800 transform transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </div>

      {open && (
        <div className="absolute mt-2 w-[150px] bg-white border rounded-[10px] z-10">
          {[{ id: "all", label: "All" }, ...plotStatusIds].map((option) => (
            <div key={option.id}>
              <div
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </div>
              <hr className="w-full h-[1px] bg-gray-200" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;
